"use client";

import { cn } from "@newxsystems/shared";
import { useRef } from "react";
import type { IDaylightSectionProps } from "./DaylightSection.props";
import { useDaylightReveal } from "./useDaylightReveal";

/**
 * The section is the client boundary for the block's motion: it renders no extra
 * element, and its props are all serializable, so every block stays a Server
 * Component and only the reveal engine ships to the browser.
 */
export const DaylightSection = ({
  children,
  className,
  containerClassName,
  containerWidth = "default",
  id,
  spacing,
}: IDaylightSectionProps) => {
  const ref = useRef<HTMLElement>(null);
  useDaylightReveal(ref);

  return (
    <section
      className={cn("daylight-block-spacing bg-background text-foreground", className)}
      data-spacing={spacing || undefined}
      id={id || undefined}
      ref={ref}
    >
      {containerWidth === "bleed" ? (
        children
      ) : (
        <div
          className={cn("daylight-container", containerClassName)}
          data-container-width={containerWidth}
        >
          {children}
        </div>
      )}
    </section>
  );
};

DaylightSection.displayName = "Content::DaylightSection";
